// extracted by mini-css-extract-plugin
export default {"wrapper":"SyncingMsg_wrapper__mCxku"};